import { render, staticRenderFns } from "./ArticleEditDialog.vue?vue&type=template&id=8360d4aa"
import script from "./ArticleEditDialog.vue?vue&type=script&lang=ts"
export * from "./ArticleEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports